// import axios from '../../static/js/request'
export default {
  namespaced: true,
  state: {
    videos: []
  },
  // mutations 修改器，用于修改state中的定义的状态变量,同步
  mutations: {
    PLAY_VIDEO(state, payload) {
      state.videos = state.videos.map((i) => {
        if (i.id === payload.id) {
          i.playing = true
        } else {
          i.playing = false
        }
        return i
      })
    },
    PAUSE_VIDEO(state, payload) {
      state.videos = state.videos.map((i) => {
        i.playing = false
        return i
      })
    },
    ADD_VIDEO(state, payload) {
      state.videos.push(payload)
    },
    REMOVE_VIDEO(state, payload) {
      state.videos.push(payload)
    },
    INSTEAD_VIDEO(state, payload) {
      state.videos = payload
    }
  },
  // 存放异步操作，由 action 去触发 mutation
  actions: {}
}
